/**
 * AMERICAN GOVERNMENT
A: Principles of American Democracy
1. What is the supreme law of the land?
▪ the Constitution
2. What does the Constitution do?
 ▪ sets up the government
 ▪ defines the government
 ▪ protects basic rights of Americans
3.	 	 The idea of self-government is in the first three words of the Constitution.What are these words?
▪ We the People
4. What is an amendment?
▪ a change (to the Constitution)
▪ an addition (to the Constitution)
5.	 	 What do we call the first ten amendments to the Constitution?
▪ the Bill of Rights
6. What is one right or freedom from the First Amendment?*
▪ speech
▪ religion
▪ assembly
▪ press
▪ petition the government
7. How many amendments does the Constitution have?
▪ twenty-seven (27)
8. What did the Declaration of Independence do?
▪ announced our independence (from Great Britain)
▪ declared our independence (from Great Britain)
▪ said that the United States is free (from Great Britain)
9. What are two rights in the Declaration of Independence?
▪ life
▪ liberty
▪ pursuit of happiness
10. What is freedom of religion?
▪ You can practice any religion, or not practice a religion.
11. What is the economic system in the United States?*
▪ capitalist economy
▪ market economy
12. What is the “rule of law”?
▪ Everyone must follow the law.
▪ Leaders must obey the law.
▪ Government must obey the law.
▪ No one is above the law.
B: System of Government
13. Name one branch or part of the government.*
▪ Congress
▪ legislative
▪ President
▪ executive
▪ the courts
▪ judicial
14. What stops one branch of government from becoming too powerful?
▪ checks and balances
▪ separation of powers
15. Who is in charge of the executive branch?
▪ the President
16. Who makes federal laws?
▪ Congress
▪ Senate and House (of Representatives)
▪ (U.S. or national) legislature
17. What are the two parts of the U.S. Congress?*
▪ the Senate and House (of Representatives)
18. How many U.S. Senators are there?
▪ one hundred (100)
19. We elect a U.S. Senator for how many years?
▪ six (6)
20. Who is one of your state’s U.S. Senators now?*
▪ Answers will vary. [District of Columbia residents and residents of U.S. territories should answer that D.C.
(or the territory where the applicant lives) has no U.S. Senators.]
21. The House of Representatives has how many voting members?
▪ four hundred thirty-five (435)
22. We elect a U.S. Representative for how many years?
▪ two (2)
23. Name your U.S. Representative.
▪ Answers will vary. [Residents of territories with nonvoting Delegates or Resident Commissioners may
provide the name of that Delegate or Commissioner. Also acceptable is any statement that the territory has
no (voting) Representatives in Congress.]
24. Who does a U.S. Senator represent?
▪ all people of the state
25. Why do some states have more Representatives than other states?
▪ (because of) the state’s population
▪ (because) they have more people
▪ (because) some states have more people
26. We elect a President for how many years?
▪ four (4)
27. In what month do we vote for President?*
▪ November
28. What is the name of the President of the United States now?*
▪ Visit uscis.gov/citizenship/testupdates for the name of the President of the United States.
29. What is the name of the Vice President of the United States now?
▪ Visit uscis.gov/citizenship/testupdates for the name of the Vice President of the United States.
30. If the President can no longer serve, who becomes President?
▪ the Vice President
31. If both the President and the Vice President can no longer serve, who becomes President?
▪ the Speaker of the House
32. Who is the Commander in Chief of the military?
▪ the President
33. Who signs bills to become laws?
▪ the President
34. Who vetoes bills?
▪ the President
35. What does the President’s Cabinet do?
▪ advises the President
36. What are two Cabinet-level positions?
▪ Secretary of Agriculture
▪ Secretary of Commerce
▪ Secretary of Defense
▪ Secretary of Education
▪ Secretary of Energy
▪ Secretary of Health and Human Services
▪ Secretary of Homeland Security
▪ Secretary of Housing and Urban Development
▪ Secretary of the Interior
▪ Secretary of Labor
▪ Secretary of State
▪ Secretary of Transportation
▪ Secretary of the Treasury
▪ Secretary of Veterans Affairs
▪ Attorney General
▪ Vice President
37. What does the judicial branch do?
▪ reviews laws
▪ explains laws
▪ resolves disputes (disagreements)
▪ decides if a law goes against the Constitution
38. What is the highest court in the United States?
▪ the Supreme Court
39. How many justices are on the Supreme Court?
▪ Visit uscis.gov/citizenship/testupdates for the number of justices on the Supreme Court.
40. Who is the Chief Justice of the United States now?
▪ Visit uscis.gov/citizenship/testupdates for the name of the Chief Justice of the United States.
41. Under our Constitution, some powers belong to the federal government. What is one power of the federal
government?
▪ to print money
▪ to declare war
▪ to create an army
▪ to make treaties
42. Under our Constitution, some powers belong to the states. What is one power of the states?
▪ provide schooling and education
▪ provide protection (police)
▪ provide safety (fire departments)
▪ give a driver’s license
▪ approve zoning and land use
43. Who is the Governor of your state now?
▪ Answers will vary. [District of Columbia residents should answer that D.C. does not have a Governor.]
44. What is the capital of your state?*
▪ Answers will vary. [District of Columbia residents should answer that D.C. is not a state and does not have a
capital. Residents of U.S. territories should name the capital of the territory.]
45. What are the two major political parties in the United States?*
▪ Democratic and Republican
46. What is the political party of the President now?
▪ Visit uscis.gov/citizenship/testupdates for the political party of the President.
47. What is the name of the Speaker of the House of Representatives now?
▪ Visit uscis.gov/citizenship/testupdates for the name of the Speaker of the House of Representatives.
C: Rights and Responsibilities
48. There are four amendments to the Constitution about who can vote. Describe one of them.
▪ Citizens eighteen (18) and older (can vote).
▪ You don’t have to pay (a poll tax) to vote.
▪ Any citizen can vote. (Women and men can vote.)
▪ A male citizen of any race (can vote).
49. What is one responsibility that is only for United States citizens?*
▪ serve on a jury
▪ vote in a federal election
50. Name one right only for United States citizens.
▪ vote in a federal election
▪ run for federal office
51. What are two rights of everyone living in the United States?
▪ freedom of expression
▪ freedom of speech
▪ freedom of assembly
▪ freedom to petition the government
▪ freedom of religion
▪ the right to bear arms
52. What do we show loyalty to when we say the Pledge of Allegiance?
▪ the United States
▪ the flag
53. What is one promise you make when you become a United States citizen?
▪ give up loyalty to other countries
▪ defend the Constitution and laws of the United States
▪ obey the laws of the United States
▪ serve in the U.S. military (if needed)
▪ serve (do important work for) the nation (if needed)
▪ be loyal to the United States
54. How old do citizens have to be to vote for President?*
▪ eighteen (18) and older
55. What are two ways that Americans can participate in their democracy?
▪ vote
▪ join a political party
▪ help with a campaign
▪ join a civic group
▪ join a community group
▪ give an elected official your opinion on an issue
▪ call Senators and Representatives
▪ publicly support or oppose an issue or policy
▪ run for office
▪ write to a newspaper
56. When is the last day you can send in federal income tax forms?*
▪ April 15
57. When must all men register for the Selective Service?
▪ at age eighteen (18)
▪ between eighteen (18) and twenty-six (26)
AMERICAN HISTORY
A: Colonial Period and Independence
58. What is one reason colonists came to America?
▪ freedom
▪ political liberty
▪ religious freedom
▪ economic opportunity
▪ practice their religion
▪ escape persecution
59. Who lived in America before the Europeans arrived?
▪ American Indians
▪ Native Americans
60. What group of people was taken to America and sold as slaves?
▪ Africans
▪ people from Africa
61.	 	 Why did the colonists fight the British?
▪ because of high taxes (taxation without representation)
▪ because the British army stayed in their houses (boarding, quartering)
▪ because they didn’t have self-government
62. Who wrote the Declaration of Independence?
▪ (Thomas) Jefferson
63. When was the Declaration of Independence adopted?
▪ July 4, 1776
64. There were 13 original states. Name three.
▪ New Hampshire
▪ Massachusetts
▪ Rhode Island
▪ Connecticut
▪ New York
▪ New Jersey
▪ Pennsylvania
▪ Delaware
▪ Maryland
▪ Virginia
▪ North Carolina
▪ South Carolina
▪ Georgia
65. What happened at the Constitutional Convention?
▪ The Constitution was written.
▪ The Founding Fathers wrote the Constitution.
66. When was the Constitution written?
▪ 1787
67. The Federalist Papers supported the passage of the U.S. Constitution. Name one of the writers.
▪ (James) Madison
▪ (Alexander) Hamilton
▪ (John) Jay
▪ Publius
68. What is one thing Benjamin Franklin is famous for?
▪ U.S. diplomat
▪ oldest member of the Constitutional Convention
▪ first Postmaster General of the United States
▪ writer of “Poor Richard’s Almanac”
▪ started the first free libraries
69. Who is the “Father of Our Country”?
▪ (George) Washington
70.	 	 Who was the first President?*
▪ (George) Washington
B: 1800s
71. What territory did the United States buy from France in 1803?
▪ the Louisiana Territory
▪ Louisiana
72. Name one war fought by the United States in the 1800s.
▪ War of 1812
▪ Mexican-American War
▪ Civil War
▪ Spanish-American War
73. Name the U.S. war between the North and the South.
▪ the Civil War
▪ the War between the States
74. Name one problem that led to the Civil War.
▪ slavery
▪ economic reasons
▪ states’ rights
75. What was one important thing that Abraham Lincoln did?*
▪ freed the slaves (Emancipation Proclamation)
▪ saved (or preserved) the Union
▪ led the United States during the Civil War
76. What did the Emancipation Proclamation do?
▪ freed the slaves
▪ freed slaves in the Confederacy
▪ freed slaves in the Confederate states
▪ freed slaves in most Southern states
77. What did Susan B. Anthony do?
▪ fought for women’s rights
▪ fought for civil rights
C: Recent American History and Other Important Historical Information
78. Name one war fought by the United States in the 1900s.*
▪ World War I
▪ World War II
▪ Korean War
▪ Vietnam War
▪ (Persian) Gulf War
79. Who was President during World War I?
▪ (Woodrow) Wilson
80. Who was President during the Great Depression and World War II?
▪ (Franklin) Roosevelt
81.	 	 Who did the United States fight in World War II?
▪ Japan, Germany, and Italy
82. Before he was President, Eisenhower was a general. What war was he in?
▪ World War II
83. During the Cold War, what was the main concern of the United States?
▪ Communism
84. What movement tried to end racial discrimination?
▪ civil rights (movement)
85. What did Martin Luther King, Jr. do?*
▪ fought for civil rights
▪ worked for equality for all Americans
86. What major event happened on September 11, 2001, in the United States?
▪ Terrorists attacked the United States.
87. Name one American Indian tribe in the United States.
 [USCIS Officers will be supplied with a list of federally recognized American Indian tribes.]
▪ Cherokee
▪ Navajo
▪ Sioux
▪ Chippewa
▪ Choctaw
▪ Pueblo
▪ Apache
▪ Iroquois
▪ Creek
▪ Blackfeet
▪ Seminole
▪ Cheyenne
▪ Arawak
▪ Shawnee
▪ Mohegan
▪ Huron
▪ Oneida
▪ Lakota
▪ Crow
▪ Teton
▪ Hopi
▪ Inuit
INTEGRATED CIVICS
A: Geography
88. Name one of the two longest rivers in the United States.
▪ Missouri (River)
▪ Mississippi (River)
89. What ocean is on the West Coast of the United States?
▪ Pacific (Ocean)
90. What ocean is on the East Coast of the United States?
▪ Atlantic (Ocean)
91. Name one U.S. territory.
▪ Puerto Rico
▪ U.S. Virgin Islands
▪ American Samoa
▪ Northern Mariana Islands
▪ Guam
92. Name one state that borders Canada.
▪ Maine
▪ New Hampshire
▪ Vermont
▪ New York
▪ Pennsylvania
▪ Ohio
▪ Michigan
▪ Minnesota
▪ North Dakota
▪ Montana
▪ Idaho
▪ Washington
▪ Alaska
93. Name one state that borders Mexico.
▪ California
▪ Arizona
▪ New Mexico
▪ Texas
94. What is the capital of the United States?*
▪ Washington, D.C.
95. Where is the Statue of Liberty?*
▪ New York (Harbor)
▪ Liberty Island
 [Also acceptable are New Jersey, near New York City, and on the Hudson (River).]
 B: Symbols
96.	 	 Why does the flag have 13 stripes?
▪ because there were 13 original colonies
▪ because the stripes represent the original colonies
97.	 	 Why does the flag have 50 stars?*
▪ because there is one star for each state
▪ because each star represents a state
▪ because there are 50 states
98. What is the name of the national anthem?
▪ The Star-Spangled Banner
C: Holidays
99. When do we celebrate Independence Day?*
▪ July 4
100. Name two national U.S. holidays.
▪ New Year’s Day
▪ Martin Luther King, Jr. Day
▪ Presidents’ Day
▪ Memorial Day
▪ Juneteenth
▪ Independence Day
▪ Labor Day
▪ Columbus Day
▪ Veterans Day
▪ Thanksgiving
▪ Christmas
 */

import Question from "../types/question";

// convert 100 QnA below to typescript with format: { question: "What is the supreme law of the land?", answer: "the Constitution", chapter: "AMERICAN GOVERNMENT", session: "Principles of American Democracy" }
const questions: Question[] = [
  {
    number: 1,
    question: "What is the supreme law of the land?",
    answer: "the Constitution",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 2,
    question: "What does the Constitution do?",
    answer: "sets up the government, defines the government, protects basic rights of Americans",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 3,
    question: "The idea of self-government is in the first three words of the Constitution. What are these words?",
    answer: "We the People",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 4,
    question: "What is an amendment?",
    answer: "a change (to the Constitution), an addition (to the Constitution)",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 5,
    question: "What do we call the first ten amendments to the Constitution?",
    answer: "the Bill of Rights",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 6,
    question: "What is one right or freedom from the First Amendment?",
    answer: "speech, religion, assembly, press, petition the government",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 7,
    question: "How many amendments does the Constitution have?",
    answer: "twenty-seven (27)",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 8,
    question: "What did the Declaration of Independence do?",
    answer: "announced our independence (from Great Britain), declared our independence (from Great Britain), said that the United States is free (from Great Britain)",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 9,
    question: "What are two rights in the Declaration of Independence?",
    answer: "life, liberty, pursuit of happiness",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 10,
    question: "What is freedom of religion?",
    answer: "You can practice any religion, or not practice a religion.",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 11,
    question: "What is the economic system in the United States?",
    answer: "capitalist economy, market economy",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 12,
    question: "What is the “rule of law”?",
    answer: "Everyone must follow the law, Leaders must obey the law, Government must obey the law, No one is above the law.",
    chapter: "AMERICAN GOVERNMENT",
    session: "Principles of American Democracy"
  },
  {
    number: 13,
    question: "Name one branch or part of the government.",
    answer: "Congress, legislative, President, executive, the courts, judicial",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 14,
    question: "What stops one branch of government from becoming too powerful?",
    answer: "checks and balances, separation of powers",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 15,
    question: "Who is in charge of the executive branch?",
    answer: "the President",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 16,
    question: "Who makes federal laws?",
    answer: "Congress, Senate and House (of Representatives), (U.S. or national) legislature",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 17,
    question: "What are the two parts of the U.S. Congress?",
    answer: "the Senate and House (of Representatives)",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 18,
    question: "How many U.S. Senators are there?",
    answer: "one hundred (100)",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 19,
    question: "We elect a U.S. Senator for how many years?",
    answer: "six (6)",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 20,
    question: "Who is one of your state’s U.S. Senators now?",
    answer: "Charles E. Schumer, Kirsten E. Gillibrand",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 21,
    question: "The House of Representatives has how many voting members?",
    answer: "four hundred thirty-five (435)",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 22,
    question: "We elect a U.S. Representative for how many years?",
    answer: "two (2)",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 23,
    question: "Name your U.S. Representative.",
    answer: "Adriano Espaillat 13th District",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 24,
    question: "Who does a U.S. Senator represent?",
    answer: "all people of the state",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 25,
    question: "Why do some states have more Representatives than other states?",
    answer: "(because of) the state’s population, (because) they have more people, (because) some states have more people",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 26,
    question: "We elect a President for how many years?",
    answer: "four (4)",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 27,
    question: "In what month do we vote for President?",
    answer: "November",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 28,
    question: "What is the name of the President of the United States now?",
    answer: "Donald J. Trump",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 29,
    question: "What is the name of the Vice President of the United States now?",
    answer: "JD Vance",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 30,
    question: "If the President can no longer serve, who becomes President?",
    answer: "the Vice President",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 31,
    question: "If both the President and the Vice President can no longer serve, who becomes President?",
    answer: "the Speaker of the House",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 32,
    question: "Who is the Commander in Chief of the military?",
    answer: "the President",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 33,
    question: "Who signs bills to become laws?",
    answer: "the President",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 34,
    question: "Who vetoes bills?",
    answer: "the President",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 35,
    question: "What does the President’s Cabinet do?",
    answer: "advises the President",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 36,
    question: "What are two Cabinet-level positions?",
    answer: "Secretary of Agriculture, Secretary of Commerce, Secretary of Defense, Secretary of Education, Secretary of Energy, Secretary of Health and Human Services, Secretary of Homeland Security, Secretary of Housing and Urban Development, Secretary of the Interior, Secretary of Labor, Secretary of State, Secretary of Transportation, Secretary of the Treasury, Secretary of Veterans Affairs, Attorney General, Vice President",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 37,
    question: "What does the judicial branch do?",
    answer: "reviews laws, explains laws, resolves disputes (disagreements), decides if a law goes against the Constitution",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 38,
    question: "What is the highest court in the United States?",
    answer: "the Supreme Court",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 39,
    question: "How many justices are on the Supreme Court?",
    answer: "nine (9)",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
  {
    number: 40,
    question: "Who is the Chief Justice of the United States now?",
    answer: "John G. Roberts, Jr.",
    chapter: "AMERICAN GOVERNMENT",
    session: "System of Government"
  },
{
  number: 41,
  question: "Under our Constitution, some powers belong to the federal government. What is one power of the federal government?",
  answer: "to print money, to declare war, to create an army, to make treaties",
  chapter: "AMERICAN GOVERNMENT",
  session: "System of Government"
},
{
  number: 42,
  question: "Under our Constitution, some powers belong to the states. What is one power of the states?",
  answer: "provide schooling and education, provide protection (police), provide safety (fire departments), give a driver’s license, approve zoning and land use",
  chapter: "AMERICAN GOVERNMENT",
  session: "System of Government"
},
{
  number: 43,
  question: "Who is the Governor of your state now?",
  answer: "Kathy Hochul",
  chapter: "AMERICAN GOVERNMENT",
  session: "System of Government"
},
{
  number: 44,
  question: "What is the capital of your state?",
  answer: "Answers will vary. [District of Columbia residents should answer that D.C. is not a state and does not have a capital. Residents of U.S. territories should name the capital of the territory.]",
  chapter: "AMERICAN GOVERNMENT",
  session: "System of Government"
},
{
  number: 45,
  question: "What are the two major political parties in the United States?",
  answer: "Democratic and Republican",
  chapter: "AMERICAN GOVERNMENT",
  session: "System of Government"
},
{
  number: 46,
  question: "What is the political party of the President now?",
  answer: "republican",
  chapter: "AMERICAN GOVERNMENT",
  session: "System of Government"
},
{
  number: 47,
  question: "What is the name of the Speaker of the House of Representatives now?",
  answer: "Mike Johnson, Johnson, James Michael Johnson (birth name)",
  chapter: "AMERICAN GOVERNMENT",
  session: "System of Government"
},
{
  number: 48,
  question: "There are four amendments to the Constitution about who can vote. Describe one of them.",
  answer: "Citizens eighteen (18) and older (can vote), You don’t have to pay (a poll tax) to vote, Any citizen can vote. (Women and men can vote.), A male citizen of any race (can vote).",
  chapter: "AMERICAN GOVERNMENT",
  session: "Rights and Responsibilities"
},
{
  number: 49,
  question: "What is one responsibility that is only for United States citizens?",
  answer: "serve on a jury, vote in a federal election",
  chapter: "AMERICAN GOVERNMENT",
  session: "Rights and Responsibilities"
},
{
  number: 50,
  question: "Name one right only for United States citizens.",
  answer: "vote in a federal election, run for federal office",
  chapter: "AMERICAN GOVERNMENT",
  session: "Rights and Responsibilities"
},
{
  number: 51,
  question: "What are two rights of everyone living in the United States?",
  answer: "freedom of expression, freedom of speech, freedom of assembly, freedom to petition the government, freedom of religion, the right to bear arms",
  chapter: "AMERICAN GOVERNMENT",
  session: "Rights and Responsibilities"
},
{
  number: 52,
  question: "What do we show loyalty to when we say the Pledge of Allegiance?",
  answer: "the United States, the flag",
  chapter: "AMERICAN GOVERNMENT",
  session: "Rights and Responsibilities"
},
{
  number: 53,
  question: "What is one promise you make when you become a United States citizen?",
  answer: "give up loyalty to other countries, defend the Constitution and laws of the United States, obey the laws of the United States, serve in the U.S. military (if needed), serve (do important work for) the nation (if needed), be loyal to the United States",
  chapter: "AMERICAN GOVERNMENT",
  session: "Rights and Responsibilities"
},
{
  number: 54,
  question: "How old do citizens have to be to vote for President?",
  answer: "eighteen (18) and older",
  chapter: "AMERICAN GOVERNMENT",
  session: "Rights and Responsibilities"
},
{
  number: 55,
  question: "What are two ways that Americans can participate in their democracy?",
  answer: "vote, join a political party, help with a campaign, join a civic group, join a community group, give an elected official your opinion on an issue, call Senators and Representatives, publicly support or oppose an issue or policy, run for office, write to a newspaper",
  chapter: "AMERICAN GOVERNMENT",
  session: "Rights and Responsibilities"
},
{
  number: 56,
  question: "When is the last day you can send in federal income tax forms?",
  answer: "April 15",
  chapter: "AMERICAN GOVERNMENT",
  session: "Rights and Responsibilities"
},
{
  number: 57,
  question: "When must all men register for the Selective Service?",
  answer: "at age eighteen (18), between eighteen (18) and twenty-six (26)",
  chapter: "AMERICAN GOVERNMENT",
  session: "Rights and Responsibilities"
},
{
  number: 58,
  question: "What is one reason colonists came to America?",
  answer: "freedom, political liberty, religious freedom, economic opportunity, practice their religion, escape persecution",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 59,
  question: "Who lived in America before the Europeans arrived?",
  answer: "American Indians, Native Americans",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 60,
  question: "What group of people was taken to America and sold as slaves?",
  answer: "Africans, people from Africa",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 61,
  question: "Why did the colonists fight the British?",
  answer: "because of high taxes (taxation without representation), because the British army stayed in their houses (boarding, quartering), because they didn’t have self-government",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 62,
  question: "Who wrote the Declaration of Independence?",
  answer: "(Thomas) Jefferson",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 63,
  question: "When was the Declaration of Independence adopted?",
  answer: "July 4, 1776",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 64,
  question: "There were 13 original states. Name three.",
  answer: "New Hampshire, Massachusetts, Rhode Island, Connecticut, New York, New Jersey, Pennsylvania, Delaware, Maryland, Virginia, North Carolina, South Carolina, Georgia",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 65,
  question: "What happened at the Constitutional Convention?",
  answer: "The Constitution was written, The Founding Fathers wrote the Constitution.",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 66,
  question: "When was the Constitution written?",
  answer: "1787",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 67,
  question: "The Federalist Papers supported the passage of the U.S. Constitution. Name one of the writers.",
  answer: "(James) Madison, (Alexander) Hamilton, (John) Jay, Publius",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 68,
  question: "What is one thing Benjamin Franklin is famous for?",
  answer: "U.S. diplomat, oldest member of the Constitutional Convention, first Postmaster General of the United States, writer of “Poor Richard’s Almanac”, started the first free libraries",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 69,
  question: "Who is the “Father of Our Country”?",
  answer: "(George) Washington",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 70,
  question: "Who was the first President?",
  answer: "(George) Washington",
  chapter: "AMERICAN HISTORY",
  session: "Colonial Period and Independence"
},
{
  number: 71,
  question: "What territory did the United States buy from France in 1803?",
  answer: "the Louisiana Territory, Louisiana",
  chapter: "AMERICAN HISTORY",
  session: "1800s"
},
{
  number: 72,
  question: "Name one war fought by the United States in the 1800s.",
  answer: "War of 1812, Mexican-American War, Civil War, Spanish-American War",
  chapter: "AMERICAN HISTORY",
  session: "1800s"
},
{
  number: 73,
  question: "Name the U.S. war between the North and the South.",
  answer: "the Civil War, the War between the States",
  chapter: "AMERICAN HISTORY",
  session: "1800s"
},
{
  number: 74,
  question: "Name one problem that led to the Civil War.",
  answer: "slavery, economic reasons, states’ rights",
  chapter: "AMERICAN HISTORY",
  session: "1800s"
},
{
  number: 75,
  question: "What was one important thing that Abraham Lincoln did?",
  answer: "freed the slaves (Emancipation Proclamation), saved (or preserved) the Union, led the United States during the Civil War",
  chapter: "AMERICAN HISTORY",
  session: "1800s"
},
{
  number: 76,
  question: "What did the Emancipation Proclamation do?",
  answer: "freed the slaves, freed slaves in the Confederacy, freed slaves in the Confederate states, freed slaves in most Southern states",
  chapter: "AMERICAN HISTORY",
  session: "1800s"
},
{
  number: 77,
  question: "What did Susan B. Anthony do?",
  answer: "fought for women’s rights, fought for civil rights",
  chapter: "AMERICAN HISTORY",
  session: "1800s"
},
{
  number: 78,
  question: "Name one war fought by the United States in the 1900s.",
  answer: "World War I, World War II, Korean War, Vietnam War, (Persian) Gulf War",
  chapter: "AMERICAN HISTORY",
  session: "Recent American History and Other Important Historical Information"
},
{
  number: 79,
  question: "Who was President during World War I?",
  answer: "(Woodrow) Wilson",
  chapter: "AMERICAN HISTORY",
  session: "Recent American History and Other Important Historical Information"
},
{
  number: 80,
  question: "Who was President during the Great Depression and World War II?",
  answer: "(Franklin) Roosevelt",
  chapter: "AMERICAN HISTORY",
  session: "Recent American History and Other Important Historical Information"
},
{
  number: 81,
  question: "Who did the United States fight in World War II?",
  answer: "Japan, Germany, and Italy",
  chapter: "AMERICAN HISTORY",
  session: "Recent American History and Other Important Historical Information"
},
{
  number: 82,
  question: "Before he was President, Eisenhower was a general. What war was he in?",
  answer: "World War II",
  chapter: "AMERICAN HISTORY",
  session: "Recent American History and Other Important Historical Information"
},
{
  number: 83,
  question: "During the Cold War, what was the main concern of the United States?",
  answer: "Communism",
  chapter: "AMERICAN HISTORY",
  session: "Recent American History and Other Important Historical Information"
},
{
  number: 84,
  question: "What movement tried to end racial discrimination?",
  answer: "civil rights (movement)",
  chapter: "AMERICAN HISTORY",
  session: "Recent American History and Other Important Historical Information"
},
{
  number: 85,
  question: "What did Martin Luther King, Jr. do?",
  answer: "fought for civil rights, worked for equality for all Americans",
  chapter: "AMERICAN HISTORY",
  session: "Recent American History and Other Important Historical Information"
},
{
  number: 86,
  question: "What major event happened on September 11, 2001, in the United States?",
  answer: "Terrorists attacked the United States.",
  chapter: "AMERICAN HISTORY",
  session: "Recent American History and Other Important Historical Information"
},
{
  number: 87,
  question: "Name one American Indian tribe in the United States.",
  answer: "Cherokee, Navajo, Sioux, Chippewa, Choctaw, Pueblo, Apache, Iroquois, Creek, Blackfeet, Seminole, Cheyenne, Arawak, Shawnee, Mohegan, Huron, Oneida, Lakota, Crow, Teton, Hopi, Inuit",
  chapter: "AMERICAN HISTORY",
  session: "Recent American History and Other Important Historical Information"
},
{
  number: 88,
  question: "Name one of the two longest rivers in the United States.",
  answer: "Missouri (River), Mississippi (River)",
  chapter: "INTEGRATED CIVICS",
  session: "Geography"
},
{
  number: 89,
  question: "What ocean is on the West Coast of the United States?",
  answer: "Pacific (Ocean)",
  chapter: "INTEGRATED CIVICS",
  session: "Geography"
},
{
  number: 90,
  question: "What ocean is on the East Coast of the United States?",
  answer: "Atlantic (Ocean)",
  chapter: "INTEGRATED CIVICS",
  session: "Geography"
},
{
  number: 91,
  question: "Name one U.S. territory.",
  answer: "Puerto Rico, U.S. Virgin Islands, American Samoa, Northern Mariana Islands, Guam",
  chapter: "INTEGRATED CIVICS",
  session: "Geography"
},
{
  number: 92,
  question: "Name one state that borders Canada.",
  answer: "Maine, New Hampshire, Vermont, New York, Pennsylvania, Ohio, Michigan, Minnesota, North Dakota, Montana, Idaho, Washington, Alaska",
  chapter: "INTEGRATED CIVICS",
  session: "Geography"
},
{
  number: 93,
  question: "Name one state that borders Mexico.",
  answer: "California, Arizona, New Mexico, Texas",
  chapter: "INTEGRATED CIVICS",
  session: "Geography"
},
{
  number: 94,
  question: "What is the capital of the United States?",
  answer: "Washington, D.C.",
  chapter: "INTEGRATED CIVICS",
  session: "Geography"
},
{
  number: 95,
  question: "Where is the Statue of Liberty?",
  answer: "New York (Harbor), Liberty Island [Also acceptable are New Jersey, near New York City, and on the Hudson (River).]",
  chapter: "INTEGRATED CIVICS",
  session: "Geography"
},
{
  number: 96,
  question: "Why does the flag have 13 stripes?",
  answer: "because there were 13 original colonies, because the stripes represent the original colonies",
  chapter: "INTEGRATED CIVICS",
  session: "Symbols"
},
{
  number: 97,
  question: "Why does the flag have 50 stars?",
  answer: "because there is one star for each state, because each star represents a state, because there are 50 states",
  chapter: "INTEGRATED CIVICS",
  session: "Symbols"
},
{
  number: 98,
  question: "What is the name of the national anthem?",
  answer: "The Star-Spangled Banner",
  chapter: "INTEGRATED CIVICS",
  session: "Symbols"
},
{
  number: 99,
  question: "When do we celebrate Independence Day?",
  answer: "July 4",
  chapter: "INTEGRATED CIVICS",
  session: "Holidays"
},
{
  number: 100,
  question: "Name two national U.S. holidays.",
  answer: "New Year’s Day, Martin Luther King, Jr. Day, Presidents’ Day, Memorial Day, Juneteenth, Independence Day, Labor Day, Columbus Day, Veterans Day, Thanksgiving, Christmas",
  chapter: "INTEGRATED CIVICS",
  session: "Holidays"
}
]

export default questions;